export const HEADER_H = 40;
export const ROW_H = 40;
export const CORE_MAX_ROWS = 9;
export const SIDE_MAX_ROWS = 4;
const SAFETY_PAD = 2;
const HSCROLL_ALLOWANCE = 16;

/**
 * Pixel height for the AG Grid wrapper sized to fit exactly `rows` data rows
 * plus the grid header — no card chrome. All three costing tables render
 * rows at 40px (`gridOptions.rowHeight: 40`). The 2px safety pad absorbs
 * AG Grid's header bottom border so the wrapper never overflows by a
 * sub-pixel. The 16px horizontal-scrollbar allowance reserves space for
 * AG Grid's bottom scrollbar at ≤1600px viewports (columns don't fit) so
 * it can't eat into the row viewport and force a spurious vertical scrollbar.
 */
export const gridHeight = (rows: number): string => `${HEADER_H + Math.max(0, rows) * ROW_H + SAFETY_PAD + HSCROLL_ALLOWANCE}px`;
